webpackJsonp([3],{

/***/ "+2P6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Post; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__("PIAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("Rn0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__articleHeader__ = __webpack_require__("zERC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__articleHeaderInfo__ = __webpack_require__("VyZ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__articleHeaderTitle__ = __webpack_require__("BXK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__articleTitle__ = __webpack_require__("UKmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__recommendedPosts__ = __webpack_require__("lGsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__socialShare__ = __webpack_require__("4xHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__trendingPosts__ = __webpack_require__("m+yB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getImgixUrl__ = __webpack_require__("4249");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_truncate__ = __webpack_require__("5Tmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_adLazyLoader__ = __webpack_require__("tNLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_adLazyLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_adLazyLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_articlePaginationNav__ = __webpack_require__("2Zqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_articlePaginationNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_articlePaginationNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_breadcrumbs__ = __webpack_require__("YO9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_calloutLink__ = __webpack_require__("vMj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_calloutLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_calloutLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_gridColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_gridRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_newsArticleAuthor__ = __webpack_require__("XhJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_newsArticleAuthor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_newsArticleAuthor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_newsletter__ = __webpack_require__("4oZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_newsletter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_backpack_ui_dist_components_socialShareContainer__ = __webpack_require__("Zf8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_backpack_ui_dist_components_socialShareContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_backpack_ui_dist_components_socialShareContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_backpack_ui_dist_components_text__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


























var Post = /** @class */ (function (_super) {
    __extends(Post, _super);
    function Post(props) {
        var _this = _super.call(this, props) || this;
        _this.processImages = _this.processImages.bind(_this);
        _this.processVideos = _this.processVideos.bind(_this);
        return _this;
    }
    Post.prototype.processImages = function () {
        var content = document.getElementById("theContent");
        var imageElements = Array.from(content.querySelectorAll("img"));
        if (imageElements) {
            imageElements.forEach(function (image) {
                var parent = image.parentNode;
                parent.className = __WEBPACK_IMPORTED_MODULE_4__styles_css__["imgContainer"];
            });
        }
    };
    Post.prototype.processVideos = function () {
        var content = document.getElementById("theContent");
        var videoElements = Array.from(content.querySelectorAll("[data-op-video-id]"));
        if (videoElements) {
            videoElements.forEach(function (video) {
                video.className += __WEBPACK_IMPORTED_MODULE_4__styles_css__["videoElementContainer"];
                video.children[0].className += __WEBPACK_IMPORTED_MODULE_0_classnames__(" videoElement", __WEBPACK_IMPORTED_MODULE_4__styles_css__["videoElement"]);
            });
        }
    };
    Post.prototype.componentDidMount = function () {
        this.processImages();
        this.processVideos();
    };
    Post.prototype.render = function () {
        var _a = this.props, post = _a.post, recommendedPosts = _a.recommendedPosts, trendingPosts = _a.trendingPosts, next = _a.next, previous = _a.previous;
        var postContent = post.content
            // tslint:disable-next-line:max-line-length
            .replace(/stable\.web\.blog-backend\.(qa|staging|production)\.lonelyplanet\.com\/wp-content\/uploads\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/media\.lonelyplanet\.com\/blog\/(qa|staging|production)\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/\.png/g, "\.png?auto=format&q=90")
            .replace(/\.jpg/g, "\.jpg?auto=format&q=90");
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "post" },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd7_Topic: "blog",
                    page_type: "blog-post-page",
                    site_section: "blog",
                } }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, post.title + " – Lonely Planet's travel blog"),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "title", content: post.title + " – Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "description", content: post.excerpt ?
                        post.excerpt :
                        // tslint:disable-next-line:max-line-length
                        "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "keywords", 
                    // tslint:disable-next-line:max-line-length
                    content: "Travel Guides, Guidebooks, Travel Advice, Travel Community, Groups, Profiles, Thorn Tree, Travelers, Travel Forum, Forum, friends, travel buddies, travel stories, humor, funny, Information, Tips, Destinations, Inspire, Inspiration, Visit, World, Cities, Health, Trips, Visas, Accommodation, Hotels, Flights, Car Hire, Insurance, Travel Gear, Cheap, Photography, Lonely Planet, Lonely Planet" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:title", content: post.title + " – Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:description", content: post.excerpt ?
                        post.excerpt :
                        // tslint:disable-next-line:max-line-length
                        "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:image", content: post.featuredImage ?
                        post.featuredImage.url :
                        "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "twitter:card", content: "summary_large_image" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "twitter:site", content: "@lonelyplanet" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("script", { type: "text/javascript", async: true, src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" })),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_adLazyLoader___default.a, { className: "ArticleSuperzoneTop", id: "ad-superzone-top", framed: true }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_container___default.a, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["postContainer"] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_breadcrumbs___default.a, { links: [
                        { title: "Blog", href: "/blog" },
                        {
                            href: "/blog/" + post.id,
                            title: Object(__WEBPACK_IMPORTED_MODULE_14__utils_truncate__["a" /* truncate */])("" + post.title, 5),
                        },
                    ] }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__articleHeader__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__articleHeaderInfo__["a" /* default */], null, post.attribution.map(function (attribute) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_newsArticleAuthor___default.a, { name: attribute.name, title: attribute.title, absoluteTime: post.publicationDate, relativeTime: __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate, "YYYYMMDD").fromNow() })); })),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__articleHeaderTitle__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__articleTitle__["a" /* default */], null, post.title))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_gridRow___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_gridColumn___default.a, { className: "ArticleContent", sm: 12, md: 7, lg: 6, lgShift: 2, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["articleContent"], id: "theContent", dangerouslySetInnerHTML: { __html: postContent } }),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleFooter", __WEBPACK_IMPORTED_MODULE_4__styles_css__["articleFooter"]) },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_backpack_ui_dist_components_socialShareContainer___default.a, { text: post.title + " – Lonely Planet's travel blog ", url: "https://www.lonelyplanet.com/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") +
                                    "/" + ("/" + post.metadata.slug), twitterContent: post.title + " – Lonely Planet's travel blog https://www.lonelyplanet.com/blog/"
                                    + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") + "/"
                                    + ("/" + post.metadata.slug) +
                                    " via @lonelyplanet", headingText: "Share this article:", via: "lonelyplanet" }, __WEBPACK_IMPORTED_MODULE_11__socialShare__["a" /* default */]))),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_gridColumn___default.a, { className: "ArticleSidebar", sm: 12, md: 4, mdShift: 1, lg: 3, lgShift: 1, includeGutter: true, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_adLazyLoader___default.a, { className: "ArticleSidebarAd", id: "ad-article-right-rail", framed: true }),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("trendingArticles", __WEBPACK_IMPORTED_MODULE_4__styles_css__["trendingArticles"]) },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["trendingHeading"], level: 6, size: 8 }, "Trending"),
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__trendingPosts__["a" /* TrendingPosts */], { posts: trendingPosts }),
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_calloutLink___default.a, { href: "/blog/category/trending", style: { marginTop: "40px" } }, "More trending"))))),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_adLazyLoader___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleSuperzoneBottom", __WEBPACK_IMPORTED_MODULE_4__styles_css__["bottomAd"]), id: "ad-superzone-bottom", framed: true }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_container___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_gridRow___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("moreArticles", __WEBPACK_IMPORTED_MODULE_4__styles_css__["moreArticles"]), sm: 12, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("header", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["header"] },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["heading"], level: 2, weight: "light" },
                                "More in ",
                                post.categories[0].name)),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__recommendedPosts__["a" /* RecommendedPosts */], { posts: recommendedPosts })))),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_newsletter___default.a, { captchaSiteKey: "6LegewcUAAAAAG-5-ZTtWJ9M8cUyz7Mh0-uzNbC_" }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "PaginationNav" }, previous && next && (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_articlePaginationNav___default.a, { previousArticle: {
                    category: "" + previous.categories[0].name,
                    href: "/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(previous.publicationDate).format("YYYY/MM/DD") + ("/" + previous.metadata.slug),
                    image: Object(__WEBPACK_IMPORTED_MODULE_13__utils_getImgixUrl__["a" /* getImgixUrl */])(previous.featuredImage ?
                        previous.featuredImage.url + "?auto=format&fit=crop&w=700&h=500&q=72" :
                        // tslint:disable-next-line:max-line-length
                        "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=700&h=500&q=72"),
                    imageAlt: "" + previous.title,
                    title: "" + previous.title,
                }, nextArticle: {
                    category: "" + next.categories[0].name,
                    href: "/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(next.publicationDate).format("YYYY/MM/DD") + ("/" + next.metadata.slug),
                    image: Object(__WEBPACK_IMPORTED_MODULE_13__utils_getImgixUrl__["a" /* getImgixUrl */])(next.featuredImage ?
                        next.featuredImage.url + "?auto=format&fit=crop&w=700&h=500&q=72" :
                        // tslint:disable-next-line:max-line-length
                        "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=700&h=500&q=72"),
                    imageAlt: "" + next.title,
                    title: "" + next.title,
                } })))));
    };
    return Post;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));



/***/ }),

/***/ "/+pM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"articleHeaderInfo":"styles__articleHeaderInfo___21mz5"};

/***/ }),

/***/ "03nD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slugify;
function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
}


/***/ }),

/***/ "158s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backgroundImage":"styles__backgroundImage___2Pefn","img":"styles__img____Lnik","heading":"styles__heading___2As2H"};

/***/ }),

/***/ "4249":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getImgixUrl;
function getImgixUrl(url) {
    if (url) {
        // tslint:disable-next-line:max-line-length
        return url.replace(/stable\.web\.blog-backend\.(qa|staging|production)\.lonelyplanet\.com\/wp-content\/uploads\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/media\.lonelyplanet\.com\/blog\/(qa|staging|production)\//g, "lonelyplanetimages.imgix.net/blog/$1/");
    }
    return null;
}


/***/ }),

/***/ "4xHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__("z8Ev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_heading__ = __webpack_require__("JQEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings__ = __webpack_require__("kl/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton__ = __webpack_require__("HaEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton__);





var SocialShare = function (_a) {
    var description = _a.description, headingText = _a.headingText, image = _a.image, style = _a.style, text = _a.text, twitterContent = _a.twitterContent, url = _a.url;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "socialShareContainer" },
        headingText &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_heading___default.a, { size: "tiny", weight: "thick", level: 5, caps: true }, headingText),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: headingText ? __WEBPACK_IMPORTED_MODULE_1__styles_css__["containerWithHeading"] : "" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings___default.a, { shareContent: {
                    description: description,
                    image: image,
                    text: text,
                    twitterContent: twitterContent,
                    url: url,
                    via: "lonelyplanet",
                } }, function (shareActions, shareUrls) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton___default.a, { network: "twitter", href: shareUrls.twitter, onClick: function (event) {
                        shareActions.twitter();
                        event.preventDefault();
                    }, className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["button"] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton___default.a, { network: "facebook", href: shareUrls.facebook, onClick: function (event) {
                        shareActions.facebook();
                        event.preventDefault();
                    }, className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["button"] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton___default.a, { network: "pinterest", href: shareUrls.pinterest, onClick: function (event) {
                        shareActions.pinterest();
                        event.preventDefault();
                    }, className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["button"] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_socialIconButton___default.a, { network: "whatsapp", href: shareUrls.whatsapp, onClick: function (event) {
                        shareActions.whatsapp();
                        event.preventDefault();
                    }, className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["button"] }))); }))));
};
/* harmony default export */ __webpack_exports__["a"] = (SocialShare);


/***/ }),

/***/ "5Tmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = truncate;
function truncate(text, words) {
    var numberOfWords = Number(words);
    var stringWords = text.split(" ").length;
    if (stringWords >= numberOfWords) {
        var truncatedString = text
            .split(/\s+/)
            .slice(0, numberOfWords)
            .join(" ");
        return "" + truncatedString + String.fromCharCode(8230);
    }
    return text;
}


/***/ }),

/***/ "Ahhh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_router__ = __webpack_require__("H7tR");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var createRoot = function (Application) { return function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_router__["a" /* Router */], __assign({}, Object(__WEBPACK_IMPORTED_MODULE_1__components_router__["b" /* getProps */])(props)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Application, __assign({}, props))));
}; };


/***/ }),

/***/ "BXK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Kjq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn__);




var ArticleHeaderTitle = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleHeader--Title", __WEBPACK_IMPORTED_MODULE_2__styles_css__["articleHeaderTitle"]), sm: 12, lg: 9, fluid: true }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ArticleHeaderTitle);


/***/ }),

/***/ "BZ1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Category; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__("PIAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_waypoint__ = __webpack_require__("TKwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__("rX7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__newsList__ = __webpack_require__("rPhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getImgixUrl__ = __webpack_require__("4249");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_ad__ = __webpack_require__("7Ya4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_ad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_ad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_breadcrumbs__ = __webpack_require__("YO9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_gridColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_backpack_ui_dist_components_gridRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_text__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};















var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category(props) {
        var _this = _super.call(this, props) || this;
        _this.handleInfiniteScroll = function () {
            if (_this.state.posts.length) {
                _this.setState({
                    page: _this.state.page + 10,
                }, function () {
                    var morePosts = false;
                    _this.fetchData(morePosts);
                });
            }
        };
        _this.state = {
            isFetching: false,
            page: 0,
            posts: _this.props.posts,
        };
        return _this;
    }
    Category.prototype.updateInitialState = function () {
        window.__initialState.moreCategoryPosts = {
            posts: this.state.posts,
        };
    };
    Category.prototype.fetchData = function (morePosts) {
        return __awaiter(this, void 0, void 0, function () {
            var response, payload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            isFetching: true,
                        });
                        return [4 /*yield*/, fetch("/blog/api/categories?categoryId=" + this.props.category.id + "&page=" + this.state.page)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        payload = _a.sent();
                        if (morePosts) {
                            window.scrollTo(0, 0);
                            this.setState({
                                isFetching: false,
                                page: this.state.page + 10,
                                posts: payload,
                            }, function () { return _this.updateInitialState(); });
                        }
                        else {
                            this.setState({
                                isFetching: false,
                                posts: this.state.posts.concat(payload),
                            }, function () { return _this.updateInitialState(); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Category.prototype.render = function () {
        var _a = this.props, posts = _a.posts, category = _a.category;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "category" },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd7_Topic: "blog",
                    page_type: "blog-category-page",
                    site_section: "blog",
                } }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, category ? category.name + " – Lonely Planet's travel blog"
                    : "Latest – Lonely Planet's travel blog"),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "title", content: category ?
                        category.name + " – Lonely Planet's travel blog" :
                        "Latest – Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "description", 
                    // tslint:disable-next-line:max-line-length
                    content: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "keywords", 
                    // tslint:disable-next-line:max-line-length
                    content: "Travel Guides, Guidebooks, Travel Advice, Travel Community, Groups, Profiles, Thorn Tree, Travelers, Travel Forum, Forum, friends, travel buddies, travel stories, humor, funny, Information, Tips, Destinations, Inspire, Inspiration, Visit, World, Cities, Health, Trips, Visas, Accommodation, Hotels, Flights, Car Hire, Insurance, Travel Gear, Cheap, Photography, Lonely Planet, Lonely Planet" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:title", content: category ?
                        category.name + " – Lonely Planet's travel blog" :
                        "Latest – Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:description", 
                    // tslint:disable-next-line:max-line-length
                    content: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:image", content: "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "twitter:card", content: "summary_large_image" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "twitter:site", content: "@lonelyplanet" })),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_container___default.a, { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["categoryMargin"] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_breadcrumbs___default.a, { links: [
                        { title: "Blog", href: "/blog" },
                        {
                            href: category ? "/blog/category/" + category.slug : "/blog/latest",
                            title: category ? "" + category.name : "Latest",
                        },
                    ] }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_backpack_ui_dist_components_gridRow___default.a, { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["categoryMargin"] },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_gridColumn___default.a, { sm: 12, className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["centerHeading"] },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_text__["Heading"], { level: 1, weight: "medium", size: 3 }, category ? category.name : "Latest")),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("Category", __WEBPACK_IMPORTED_MODULE_5__styles_css__["categoryMargin"]), sm: 12, md: 7, lg: 6, lgShift: 1, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__newsList__["a" /* default */], { newsItems: this.state.posts.map(function (cat) { return ({
                                category: "" + cat.categories[0].name,
                                categoryLink: "/blog/category/" + cat.categories[0].slug,
                                link: "/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(cat.publicationDate).format("YYYY/MM/DD") + ("/" + cat.metadata.slug),
                                thumbnail: Object(__WEBPACK_IMPORTED_MODULE_8__utils_getImgixUrl__["a" /* getImgixUrl */])(cat.featuredImage ?
                                    cat.featuredImage.url + "?auto=format&fit=crop&w=110&h=110&q=72" :
                                    // tslint:disable-next-line:max-line-length
                                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=110&h=110&q=72"),
                                title: "" + cat.title,
                            }); }) }),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_waypoint__, { onEnter: this.handleInfiniteScroll })),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_gridColumn___default.a, { sm: 12, md: 4, mdShift: 1, lg: 3, lgShift: 1, className: __WEBPACK_IMPORTED_MODULE_0_classnames__("categoryAds", __WEBPACK_IMPORTED_MODULE_5__styles_css__["categoryAds"]), fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_ad___default.a, { className: "CategoryAds", id: "ad-list-right-rail", framed: true }))))));
    };
    return Category;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));



/***/ }),

/***/ "E8nV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createExcerpt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_truncate__ = __webpack_require__("5Tmr");

function createExcerpt(content) {
    if (content) {
        var contentNoImages = content.replace(/<img[^>]*>/g, "");
        var contentTruncated = Object(__WEBPACK_IMPORTED_MODULE_0__utils_truncate__["a" /* truncate */])(contentNoImages, 25);
        return contentTruncated;
    }
    return null;
}


/***/ }),

/***/ "GAMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root__ = __webpack_require__("nGOu");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/* tslint:disable */



var initialState = JSON.parse(document.getElementById("initialState").textContent);
window.__initialState = initialState;
Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["hydrate"])(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__root__["a" /* default */], __assign({}, initialState)), document.getElementById("app"));
if (false) {
    module.hot.accept("./root", function () {
        var NewRoot = require("./root").default;
        hydrate(React.createElement(NewRoot, __assign({}, window.__initialState)), document.getElementById("app"));
    });
}


/***/ }),

/***/ "H7tR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__("ciQf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("F8kA");


var Router = typeof window !== "undefined" ? __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Router */] : __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* StaticRouter */];
var getProps = function (_a) {
    var location = _a.location;
    return typeof window !== "undefined" ? {
        history: __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()(),
    } : {
        context: {},
        location: location,
    };
};



/***/ }),

/***/ "Kjq5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"articleHeaderTitle":"styles__articleHeaderTitle___2RFI2"};

/***/ }),

/***/ "NjDn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"anchor":"styles__anchor___1daOr","column1":"styles__column1___37PiN","column2":"styles__column2___23tuL","footer":"styles__footer___zEPC7","header":"styles__header___2MzbU","heading":"styles__heading___1bj-p","paragraph":"styles__paragraph___3fzEh","postHighlightContainer":"styles__postHighlightContainer___3U0Rv","textContainer":"styles__textContainer___2bGnG"};

/***/ }),

/***/ "Rn0q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"articleContent":"styles__articleContent___23kR5","imgContainer":"styles__imgContainer___HOYJn","articleFooter":"styles__articleFooter___AeO5p","heading":"styles__heading___3mXCz","header":"styles__header___WGuMR","moreArticles":"styles__moreArticles___thE1s","postContainer":"styles__postContainer___rgHQB","trendingArticles":"styles__trendingArticles___2Aj40","trendingHeading":"styles__trendingHeading____vDH7","bottomAd":"styles__bottomAd___2OjGn","videoElement":"styles__videoElement___1b73y","videoElementContainer":"styles__videoElementContainer___2uklX"};

/***/ }),

/***/ "UKmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_heading__ = __webpack_require__("JQEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_heading__);


var ArticleTitle = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_heading___default.a, { level: 1, weight: "thick", size: "large" }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ArticleTitle);


/***/ }),

/***/ "VyZ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("/+pM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn__);




var ArticleHeaderInfo = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleHeaderInfo", __WEBPACK_IMPORTED_MODULE_2__styles_css__["articleHeaderInfo"]), sm: 12, md: 3, lg: 2, fluid: true }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ArticleHeaderInfo);


/***/ }),

/***/ "YxN4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"marginTop":"styles__marginTop___3KL8A","tabbedNavRow":"styles__tabbedNavRow___d2eJD"};

/***/ }),

/***/ "aqOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("xsyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var ListContainer = function (_a) {
    var adSlot = _a.adSlot, className = _a.className, items = _a.items, styleOverride = _a.styleOverride;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "" + __WEBPACK_IMPORTED_MODULE_0_classnames__("ListContainer", className) },
        adSlot,
        items.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ListItemContainer", __WEBPACK_IMPORTED_MODULE_2__styles_css__["listItemContainer"], styleOverride), key: index }, item)); })));
};
/* harmony default export */ __webpack_exports__["a"] = (ListContainer);


/***/ }),

/***/ "bOjH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_iframe__ = __webpack_require__("X3HN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("n4Bh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_adLazyLoader__ = __webpack_require__("tNLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_adLazyLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_adLazyLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_calloutLink__ = __webpack_require__("vMj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_calloutLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_calloutLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_gridRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_masthead__ = __webpack_require__("esVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_masthead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_masthead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_newsletter__ = __webpack_require__("4oZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_newsletter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_socialShareContainer__ = __webpack_require__("Zf8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_socialShareContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_socialShareContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet__ = __webpack_require__("PIAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mastheadBackground__ = __webpack_require__("qdDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_featuredPosts__ = __webpack_require__("k4Ob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_latestPosts__ = __webpack_require__("gWW/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_postHighlight__ = __webpack_require__("tMiX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_socialShare__ = __webpack_require__("4xHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_tabbedCategories__ = __webpack_require__("h5pz");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





















var Blog = /** @class */ (function (_super) {
    __extends(Blog, _super);
    function Blog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Blog.prototype.render = function () {
        var _a = this.props, featuredPosts = _a.featuredPosts, latestPosts = _a.latestPosts, postHighlight = _a.postHighlight, catBehindTheScenes = _a.catBehindTheScenes, catCommunity = _a.catCommunity, catPathfinders = _a.catPathfinders, catQuizCompetitions = _a.catQuizCompetitions, catWonderings = _a.catWonderings;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("main", { className: "main" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd7_Topic: "blog",
                    page_type: "blog",
                    site_section: "blog",
                } }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_helmet___default.a, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("title", null, "Unpacked - Lonely Planet's travel blog"),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { name: "title", content: "Unpacked - Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { name: "description", 
                    // tslint:disable-next-line:max-line-length
                    content: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { name: "keywords", 
                    // tslint:disable-next-line:max-line-length
                    content: "Travel Guides, Guidebooks, Travel Advice, Travel Community, Groups, Profiles, Thorn Tree, Travelers, Travel Forum, Forum, friends, travel buddies, travel stories, humor, funny, Information, Tips, Destinations, Inspire, Inspiration, Visit, World, Cities, Health, Trips, Visas, Accommodation, Hotels, Flights, Car Hire, Insurance, Travel Gear, Cheap, Photography, Lonely Planet, Lonely Planet" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { property: "og:title", content: "Unpacked - Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { property: "og:description", 
                    // tslint:disable-next-line:max-line-length
                    content: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { property: "og:image", content: "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { name: "twitter:card", content: "summary_large_image" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("meta", { name: "twitter:site", content: "@lonelyplanet" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("script", { type: "text/javascript", async: true, src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("script", { src: "https://cdn.lightwidget.com/widgets/lightwidget.js" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_backpack_ui_dist_components_masthead___default.a, { isUnderGlobalHeader: true },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_mastheadBackground__["a" /* default */], { backgroundImage: "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000", backgroundHeight: "70vh", logoImage: "https://lonelyplanetstatic.imgix.net/blog/masthead_unpacked_logo.png", logoWidth: "600px", logoAlt: "Blog Unpacked Logo", text: "The stories behind the passport stamps" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_container___default.a, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["section1"] },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_gridRow___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridColumn___default.a, { sm: 12, lg: 8, fluid: true, className: "FeaturedArticles" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["sectionHeading"], level: 2, weight: "light" }, "Featured"),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_featuredPosts__["a" /* FeaturedPosts */], { posts: featuredPosts })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridColumn___default.a, { className: "LatestArticles", sm: 12, lg: 3, lgShift: 1, includeGutter: true, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["sectionHeading"], level: 2, weight: "light" }, "Latest"),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_latestPosts__["a" /* LatestPosts */], { posts: latestPosts }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_calloutLink___default.a, { style: { marginTop: "20px" }, href: "/blog/latest" }, "More latest")))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_adLazyLoader___default.a, { className: "FrontpageAdSuperzone", id: "ad-home-superzone", framed: true }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("hr", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("container", __WEBPACK_IMPORTED_MODULE_3__styles_css__["hr"]) }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__components_postHighlight__["a" /* PostHighlight */], { posts: postHighlight }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_backpack_ui_dist_components_newsletter___default.a, { captchaSiteKey: "6LegewcUAAAAAG-5-ZTtWJ9M8cUyz7Mh0-uzNbC_" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__components_tabbedCategories__["a" /* TabbedCategories */], { catBehindTheScenes: catBehindTheScenes, catCommunity: catCommunity, catPathfinders: catPathfinders, catQuizCompetitions: catQuizCompetitions, catWonderings: catWonderings }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_container___default.a, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("FrontpageFooter--share", __WEBPACK_IMPORTED_MODULE_3__styles_css__["socialShare"]) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_backpack_ui_dist_components_socialShareContainer___default.a
                    // tslint:disable-next-line:max-line-length
                    , { 
                        // tslint:disable-next-line:max-line-length
                        text: "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!", url: "https://www.lonelyplanet.com/blog/", twitterContent: "Unpacked - Lonely Planet's travel blog https://www.lonelyplanet.com/blog/ via @lonelyplanet", headingText: "Share the love" }, __WEBPACK_IMPORTED_MODULE_19__components_socialShare__["a" /* default */])),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_iframe___default.a, { url: "https://cdn.lightwidget.com/widgets/a94c7e79308e549f875e9912248f1177.html", position: "relative", scrolling: "no", allowtransparency: "true", className: __WEBPACK_IMPORTED_MODULE_0_classnames__("lightwidget-widget", __WEBPACK_IMPORTED_MODULE_3__styles_css__["instagramFeed"]) })))));
    };
    return Blog;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Blog);


/***/ }),

/***/ "e9aK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiBase; });
/* unused harmony export listRoutes */
/* unused harmony export poisRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return profileRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return blogRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bookmarkRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchRoutes; });
/**
 * Make sure to prefix any AJAX calls with this API base
 */
var apiBase = "/dot-api/";
var listRoutes = {
    show: "/profile/:username/bookmarks",
};
var poisRoutes = {
    detail: ":slug(.*)?/a/:type/:id/:placeId",
    list: "(.*)?/a/:type-:subtype/:id$",
    lodgingAvailability: apiBase + "lodgings/availability/:lodgingId",
    nearby: apiBase + "pois/:id/nearby",
};
var profileRoutes = {
    show: "/profile/:username",
};
var blogRoutes = {
    previewPost: "/blog/preview/:wordpressId/",
    rss: "/blog/feed/atom",
    show: "/blog",
    showCategory: "/blog/category/:slug/:id?",
    showCategoryLatest: "/blog/latest",
    showPost: "/blog/:year/:month/:day/:slug/:id?",
};
var bookmarkRoutes = {
    show: "/profile/:username/lists/:listId?",
    showList: "/profile/api/:username/lists",
};
var searchRoutes = {
    searchApi: "/search/api",
    show: "/search",
    showJson: "/search.json",
    showLegacy: "/searchResult",
    showPreview: "/search-preview",
};


/***/ }),

/***/ "gWW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LatestPosts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("ldxT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_newsList__ = __webpack_require__("rPhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getImgixUrl__ = __webpack_require__("4249");





var LatestPosts = function (_a) {
    var posts = _a.posts;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_newsList__["a" /* default */], { newsItems: posts.map(function (post) { return ({
                category: post.categories[0].name,
                categoryLink: "/blog/category/" + post.categories[0].slug,
                link: "/blog/" + __WEBPACK_IMPORTED_MODULE_0_moment__(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                size: "small",
                thumbnail: Object(__WEBPACK_IMPORTED_MODULE_4__utils_getImgixUrl__["a" /* getImgixUrl */])(post.featuredImage ?
                    post.featuredImage.url + "?auto=format&fit=crop&w=80&h=80&q=72" :
                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=80&h=80&q=72"),
                title: post.title,
            }); }), styleOverride: __WEBPACK_IMPORTED_MODULE_2__styles_css__["latestPosts"] })));
};


/***/ }),

/***/ "h5pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabbedCategories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("YxN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_ad__ = __webpack_require__("7Ya4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_ad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_ad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_calloutLink__ = __webpack_require__("vMj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_calloutLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_calloutLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_tabbedNav__ = __webpack_require__("MMdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_tabbedNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_tabbedNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__newsList__ = __webpack_require__("rPhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getImgixUrl__ = __webpack_require__("4249");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_slugify__ = __webpack_require__("03nD");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var TabbedCategories = /** @class */ (function (_super) {
    __extends(TabbedCategories, _super);
    function TabbedCategories(props) {
        var _this = _super.call(this, props) || this;
        // Category Names
        var tabTitles = [
            "Behind the scenes",
            "Community",
            "Pathfinders",
            "Quizzes and Competitions",
            "Wonderings",
        ];
        // Default First Category Articles
        var tabArticles = _this.props.catBehindTheScenes;
        _this.state = {
            activeCat: "Behind the scenes",
            tabArticles: tabArticles,
            tabTitles: tabTitles,
            tabbedCalloutLink: "/blog/category/behind-the-scenes",
        };
        _this.changeTabbedArticles = _this.changeTabbedArticles.bind(_this);
        return _this;
    }
    TabbedCategories.prototype.changeTabbedArticles = function (event) {
        var button = event.target;
        var catName = button.textContent || button.innerText;
        var catNameSlug = Object(__WEBPACK_IMPORTED_MODULE_12__utils_slugify__["a" /* slugify */])(catName);
        var activeCatPosts;
        if (catName === "Behind the scenes") {
            activeCatPosts = this.props.catBehindTheScenes;
        }
        else if (catName === "Community") {
            activeCatPosts = this.props.catCommunity;
            catNameSlug = "lp-community";
        }
        else if (catName === "Pathfinders") {
            activeCatPosts = this.props.catPathfinders;
            catNameSlug = "lp-pathfinders";
        }
        else if (catName === "Quizzes and Competitions") {
            activeCatPosts = this.props.catQuizCompetitions;
        }
        else if (catName === "Wonderings") {
            activeCatPosts = this.props.catWonderings;
        }
        if (catName !== this.state.activeCat) {
            this.setState({
                activeCat: catName,
            });
            this.setState({
                tabArticles: activeCatPosts,
            });
            this.setState({
                tabbedCalloutLink: catNameSlug === "behind-the-scenes"
                    ? "/blog/category/behind-the-scenes"
                    : "/blog/category/" + catNameSlug,
            });
        }
    };
    TabbedCategories.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("TabbedNavRow", __WEBPACK_IMPORTED_MODULE_3__styles_css__["tabbedNavRow"]) },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default.a, { sm: 12, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_tabbedNav___default.a, { active: this.state.activeCat, items: this.state.tabTitles, onClick: function (e) {
                                _this.changeTabbedArticles(e);
                            } }))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["marginTop"], sm: 12, md: 6, lg: 6, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "TabbedArticles" },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__newsList__["a" /* default */], { newsItems: this.state.tabArticles.map(function (post) { return ({
                                    category: _this.state.activeCat,
                                    categoryLink: _this.state.tabbedCalloutLink,
                                    link: "/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                                    thumbnail: Object(__WEBPACK_IMPORTED_MODULE_11__utils_getImgixUrl__["a" /* getImgixUrl */])(post.featuredImage ?
                                        post.featuredImage.url + "?auto=format&fit=crop&w=110&h=110&q=72" :
                                        // tslint:disable-next-line:max-line-length
                                        "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=110&h=110&q=72"),
                                    title: post.title,
                                }); }) }),
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_calloutLink___default.a, { href: this.state.tabbedCalloutLink }, "More blog posts"))),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["marginTop"], sm: 12, md: 4, mdShift: 2, lg: 4, lgShift: 1, includeGutter: true, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_ad___default.a, { className: "FrontpageAdRail", id: "ad-home-right-rail", framed: true }))))));
    };
    return TabbedCategories;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));



/***/ }),

/***/ "hUzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ArticlePreview":"styles__ArticlePreview___1iOxe"};

/***/ }),

/***/ "k4Ob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeaturedPosts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("hUzy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_recommendedArticles__ = __webpack_require__("5dyX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_recommendedArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_recommendedArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_createExcerpt__ = __webpack_require__("E8nV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getImgixUrl__ = __webpack_require__("4249");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_truncate__ = __webpack_require__("5Tmr");







var FeaturedPosts = function (_a) {
    var posts = _a.posts;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_recommendedArticles___default.a, { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["ArticlePreview"], calloutLabel: "More featured", calloutHref: "/blog/category/featured", articles: posts.map(function (post) { return ({
                category: post.categories[0].name,
                categoryHref: "/blog/category/" + post.categories[0].slug,
                href: "/blog/" + __WEBPACK_IMPORTED_MODULE_0_moment__(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                image: Object(__WEBPACK_IMPORTED_MODULE_5__utils_getImgixUrl__["a" /* getImgixUrl */])(post.featuredImage ?
                    post.featuredImage.url + "?auto=format&fit=crop&w=600&h=400&q=72" :
                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=600&h=400&q=72"),
                paragraph: post.excerpt ?
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_truncate__["a" /* truncate */])(post.excerpt, 25) :
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils_createExcerpt__["a" /* createExcerpt */])(post.content),
                title: post.title,
            }); }) })));
};


/***/ }),

/***/ "kvgJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"articleContent":"styles__articleContent___2-9JO","imgContainer":"styles__imgContainer___1zflk","articleFooter":"styles__articleFooter___2RDAm","heading":"styles__heading___5UZU8","header":"styles__header___1R6a4","moreArticles":"styles__moreArticles___tGVK0","postContainer":"styles__postContainer___3nERx","trendingArticles":"styles__trendingArticles___1iui0","trendingHeading":"styles__trendingHeading___3lqFs","bottomAd":"styles__bottomAd___1xTYT","videoElement":"styles__videoElement___11PQ6","videoElementContainer":"styles__videoElementContainer___3tKh1"};

/***/ }),

/***/ "lGsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecommendedPosts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_recommendedArticles__ = __webpack_require__("5dyX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_recommendedArticles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_recommendedArticles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createExcerpt__ = __webpack_require__("E8nV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getImgixUrl__ = __webpack_require__("4249");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_truncate__ = __webpack_require__("5Tmr");






var RecommendedPosts = function (_a) {
    var posts = _a.posts;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_recommendedArticles___default.a, { articles: posts.map(function (post) { return ({
                category: post.categories[0].name,
                categoryHref: "/blog/category/" + post.categories[0].slug,
                href: "/blog/" + __WEBPACK_IMPORTED_MODULE_0_moment__(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                image: Object(__WEBPACK_IMPORTED_MODULE_4__utils_getImgixUrl__["a" /* getImgixUrl */])(post.featuredImage ?
                    post.featuredImage.url + "?auto=format&fit=crop&w=600&h=400&q=72" :
                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=600&h=400&q=72"),
                paragraph: post.excerpt ? Object(__WEBPACK_IMPORTED_MODULE_5__utils_truncate__["a" /* truncate */])(post.excerpt, 25) : Object(__WEBPACK_IMPORTED_MODULE_3__utils_createExcerpt__["a" /* createExcerpt */])(post.content),
                title: post.title,
            }); }) })));
};


/***/ }),

/***/ "ldxT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"latestPosts":"styles__latestPosts___ckfOu"};

/***/ }),

/***/ "m+yB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrendingPosts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_newsList__ = __webpack_require__("rPhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getImgixUrl__ = __webpack_require__("4249");




var TrendingPosts = function (_a) {
    var posts = _a.posts;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_newsList__["a" /* default */], { newsItems: posts.map(function (post) { return ({
                category: post.categories[0].name,
                categoryLink: "/blog/category/" + post.categories[0].slug,
                link: "/blog/" + __WEBPACK_IMPORTED_MODULE_0_moment__(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                size: "small",
                thumbnail: Object(__WEBPACK_IMPORTED_MODULE_3__utils_getImgixUrl__["a" /* getImgixUrl */])(post.featuredImage ?
                    post.featuredImage.url + "?auto=format&fit=crop&w=80&h=80&q=72" :
                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=80&h=80&q=72"),
                title: post.title,
            }); }) })));
};


/***/ }),

/***/ "mU/R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"articleHeader":"styles__articleHeader___mPuDK"};

/***/ }),

/***/ "n4Bh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sectionHeading":"styles__sectionHeading___-denC","section1":"styles__section1___3aLPc","hr":"styles__hr___3-NrL","socialShare":"styles__socialShare___2tGY_","instagramFeed":"styles__instagramFeed___1tJDw"};

/***/ }),

/***/ "nGOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_createRoot__ = __webpack_require__("Ahhh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("s5En");


var Root = Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils_createRoot__["a" /* createRoot */])(__WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (Root);


/***/ }),

/***/ "qdDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("158s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text__);





var MastheadBackground = function (_a) {
    var backgroundImage = _a.backgroundImage, backgroundHeight = _a.backgroundHeight, logoImage = _a.logoImage, logoWidth = _a.logoWidth, logoAlt = _a.logoAlt, text = _a.text;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("MastheadBackground", __WEBPACK_IMPORTED_MODULE_2__styles_css__["backgroundImage"]), style: {
            backgroundImage: "url(" + backgroundImage + ")",
            height: "" + backgroundHeight,
        } },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_container___default.a, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["img"], src: logoImage, width: logoWidth, alt: logoAlt }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["heading"], level: 1, weight: "light" }, text))));
};
/* harmony default export */ __webpack_exports__["a"] = (MastheadBackground);


/***/ }),

/***/ "rPhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_listItemNews__ = __webpack_require__("TV5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_listItemNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_listItemNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_listContainer__ = __webpack_require__("aqOB");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var NewsList = function (_a) {
    var adSlot = _a.adSlot, newsItems = _a.newsItems, styleOverride = _a.styleOverride;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_listContainer__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("NewsList"), adSlot: adSlot, items: newsItems.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_listItemNews___default.a, __assign({ key: index }, item))); }), styleOverride: styleOverride }));
};
/* harmony default export */ __webpack_exports__["a"] = (NewsList);


/***/ }),

/***/ "rX7o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"categoryAds":"styles__categoryAds___1mNIQ","categoryMargin":"styles__categoryMargin___39XSi","centerHeading":"styles__centerHeading___173Li"};

/***/ }),

/***/ "s5En":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("bOjH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium__ = __webpack_require__("i2KN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_asset__ = __webpack_require__("xVEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_constants__ = __webpack_require__("e9aK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_category__ = __webpack_require__("BZ1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_post__ = __webpack_require__("+2P6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_postPreview__ = __webpack_require__("sz/I");









/* harmony default export */ __webpack_exports__["a"] = (function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_radium__["a" /* StyleRoot */], { radiumConfig: {
            userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/537.36 (KHTML, like Gecko)          Chrome/64.0.3282.186 Safari/537.36",
        } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_asset__["a" /* default */], { src: "blog.js" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_asset__["a" /* default */], { src: "blog.css" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_5__shared_constants__["b" /* blogRoutes */].show, exact: true, render: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */], { featuredPosts: props.featuredPosts, latestPosts: props.latestPosts, postHighlight: props.postHighlight, catBehindTheScenes: props.catBehindTheScenes, catCommunity: props.catCommunity, catPathfinders: props.catPathfinders, catQuizCompetitions: props.catQuizCompetitions, catWonderings: props.catWonderings })); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_5__shared_constants__["b" /* blogRoutes */].showPost, render: function (_a) {
                    var match = _a.match;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_post__["a" /* Post */], { post: props.blogPost, next: props.next, previous: props.previous, trendingPosts: props.trendingPosts, recommendedPosts: props.recommendedPosts }));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_5__shared_constants__["b" /* blogRoutes */].previewPost, render: function (_a) {
                    var match = _a.match;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_postPreview__["a" /* PostPreview */], { post: props.previewPost, trendingPosts: props.trendingPosts, recommendedPosts: props.recommendedPosts }));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_5__shared_constants__["b" /* blogRoutes */].showCategory, render: function (_a) {
                    var match = _a.match;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_category__["a" /* Category */], { posts: props.blogPosts, category: props.blogPosts[0].categories
                            .find(function (cat) { return cat.id === props.categoryId; }) }));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_5__shared_constants__["b" /* blogRoutes */].showCategoryLatest, exact: true, render: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_category__["a" /* Category */], { posts: props.categoryLatest })); } }))));
});


/***/ }),

/***/ "sxtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reducePropsToState */
/* unused harmony export handleStateChangeOnClient */
/* unused harmony export createDataLayerScript */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect__ = __webpack_require__("vAAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_side_effect__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var reducePropsToState = function (propsList) { return propsList.reduce(function (memo, m) { return (__assign({}, memo, m.data)); }, {}); };
var handleStateChangeOnClient = function (state) {
    if (typeof window !== "undefined" && window.lp && window.lp.analytics && window.lp.analytics.dataLayer) {
        window.lp.analytics.dataLayer[0] = state;
    }
};
var createDataLayerScript = function (state) { return "\n  window.lp = window.lp || {};\n  window.lp.analytics = window.lp.analytics || {};\n  window.lp.analytics.dataLayer = [" + JSON.stringify(state) + "];\n  " + ( false ? "window.lp.analytics.send = function(options) {\n    console.group(\"GTM\"); console.info(options); console.groupEnd(\"GTM\");\n  }" : "") + "\n  window.dataLayer = window.lp.analytics.dataLayer;\n"; };
var mapStateOnServer = function (state) { return createDataLayerScript(state); };
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_side_effect__(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(function () { return null; }));


/***/ }),

/***/ "sz/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PostPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__("PIAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("kvgJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__articleHeader__ = __webpack_require__("zERC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__articleHeaderInfo__ = __webpack_require__("VyZ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__articleHeaderTitle__ = __webpack_require__("BXK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__articleTitle__ = __webpack_require__("UKmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__recommendedPosts__ = __webpack_require__("lGsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__socialShare__ = __webpack_require__("4xHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__trendingPosts__ = __webpack_require__("m+yB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_truncate__ = __webpack_require__("5Tmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_adLazyLoader__ = __webpack_require__("tNLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_adLazyLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_adLazyLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_breadcrumbs__ = __webpack_require__("YO9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_calloutLink__ = __webpack_require__("vMj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_calloutLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_calloutLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_gridColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_gridRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_newsArticleAuthor__ = __webpack_require__("XhJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_newsArticleAuthor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_newsArticleAuthor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_newsletter__ = __webpack_require__("4oZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_newsletter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_socialShareContainer__ = __webpack_require__("Zf8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_socialShareContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_socialShareContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_text__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
























var PostPreview = /** @class */ (function (_super) {
    __extends(PostPreview, _super);
    function PostPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.processImages = _this.processImages.bind(_this);
        _this.processVideos = _this.processVideos.bind(_this);
        return _this;
    }
    PostPreview.prototype.processImages = function () {
        var content = document.getElementById("theContent");
        var imageElements = Array.from(content.querySelectorAll("img"));
        if (imageElements) {
            imageElements.forEach(function (image) {
                var parent = image.parentNode;
                parent.className = __WEBPACK_IMPORTED_MODULE_4__styles_css__["imgContainer"];
            });
        }
    };
    PostPreview.prototype.processVideos = function () {
        var content = document.getElementById("theContent");
        var videoElements = Array.from(content.querySelectorAll("[data-op-video-id]"));
        if (videoElements) {
            videoElements.forEach(function (video) {
                video.className += __WEBPACK_IMPORTED_MODULE_4__styles_css__["videoElementContainer"];
                video.children[0].className += __WEBPACK_IMPORTED_MODULE_0_classnames__(" videoElement", __WEBPACK_IMPORTED_MODULE_4__styles_css__["videoElement"]);
            });
        }
    };
    PostPreview.prototype.componentDidMount = function () {
        this.processImages();
        this.processVideos();
    };
    PostPreview.prototype.render = function () {
        var _a = this.props, post = _a.post, recommendedPosts = _a.recommendedPosts, trendingPosts = _a.trendingPosts;
        var postContent = post.content
            // tslint:disable-next-line:max-line-length
            .replace(/stable\.web\.blog-backend\.(qa|staging|production)\.lonelyplanet\.com\/wp-content\/uploads\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/media\.lonelyplanet\.com\/blog\/(qa|staging|production)\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/\.png/g, "\.png?auto=format&q=90")
            .replace(/\.jpg/g, "\.jpg?auto=format&q=90");
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "post" },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd7_Topic: "blog",
                    page_type: "blog-post-page",
                    site_section: "blog",
                } }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { "http-equiv": "X-UA-Compatible", content: "IE=edge" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, post.title + " – Lonely Planet's travel blog"),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "title", content: post.title + " – Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "description", content: post.excerpt ?
                        post.excerpt :
                        // tslint:disable-next-line:max-line-length
                        "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "keywords", 
                    // tslint:disable-next-line:max-line-length
                    content: "Travel Guides, Guidebooks, Travel Advice, Travel Community, Groups, Profiles, Thorn Tree, Travelers, Travel Forum, Forum, friends, travel buddies, travel stories, humor, funny, Information, Tips, Destinations, Inspire, Inspiration, Visit, World, Cities, Health, Trips, Visas, Accommodation, Hotels, Flights, Car Hire, Insurance, Travel Gear, Cheap, Photography, Lonely Planet, Lonely Planet" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:title", content: post.title + " – Lonely Planet's travel blog" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:description", content: post.excerpt ?
                        post.excerpt :
                        // tslint:disable-next-line:max-line-length
                        "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:image", content: post.featuredImage ?
                        post.featuredImage.url :
                        "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "twitter:card", content: "summary_large_image" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { name: "twitter:site", content: "@lonelyplanet" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("script", { type: "text/javascript", async: true, src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" })),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_adLazyLoader___default.a, { className: "ArticleSuperzoneTop", id: "ad-superzone-top", framed: true }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_container___default.a, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["postContainer"] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_backpack_ui_dist_components_breadcrumbs___default.a, { links: [
                        { title: "Blog", href: "/blog" },
                        {
                            href: "/blog/" + post.id,
                            title: Object(__WEBPACK_IMPORTED_MODULE_13__utils_truncate__["a" /* truncate */])("" + post.title, 5),
                        },
                    ] }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__articleHeader__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__articleHeaderInfo__["a" /* default */], null, post.attribution.map(function (attribute) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_backpack_ui_dist_components_newsArticleAuthor___default.a, { name: attribute.name, title: attribute.title, absoluteTime: post.publicationDate, relativeTime: __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate, "YYYYMMDD").fromNow() })); })),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__articleHeaderTitle__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__articleTitle__["a" /* default */], null, post.title))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_gridRow___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_gridColumn___default.a, { className: "ArticleContent", sm: 12, md: 7, lg: 6, lgShift: 2, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["articleContent"], id: "theContent", dangerouslySetInnerHTML: { __html: postContent } }),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleFooter", __WEBPACK_IMPORTED_MODULE_4__styles_css__["articleFooter"]) },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_backpack_ui_dist_components_socialShareContainer___default.a, { text: post.title + " – Lonely Planet's travel blog ", url: "https://www.lonelyplanet.com/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") +
                                    "/" + ("/" + post.metadata.slug), twitterContent: post.title + " – Lonely Planet's travel blog https://www.lonelyplanet.com/blog/"
                                    + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") + "/"
                                    + ("/" + post.metadata.slug) +
                                    " via @lonelyplanet", headingText: "Share this article:", via: "lonelyplanet" }, __WEBPACK_IMPORTED_MODULE_11__socialShare__["a" /* default */]))),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_gridColumn___default.a, { className: "ArticleSidebar", sm: 12, md: 4, mdShift: 1, lg: 3, lgShift: 1, includeGutter: true, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_adLazyLoader___default.a, { className: "ArticleSidebarAd", id: "ad-article-right-rail", framed: true }),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("trendingArticles", __WEBPACK_IMPORTED_MODULE_4__styles_css__["trendingArticles"]) },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["trendingHeading"], level: 6, size: 8 }, "Trending"),
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__trendingPosts__["a" /* TrendingPosts */], { posts: trendingPosts }),
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_backpack_ui_dist_components_calloutLink___default.a, { href: "/blog/category/trending", style: { marginTop: "40px" } }, "More trending"))))),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_backpack_ui_dist_components_adLazyLoader___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleSuperzoneBottom", __WEBPACK_IMPORTED_MODULE_4__styles_css__["bottomAd"]), id: "ad-superzone-bottom", framed: true }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_backpack_ui_dist_components_container___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_backpack_ui_dist_components_gridRow___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("moreArticles", __WEBPACK_IMPORTED_MODULE_4__styles_css__["moreArticles"]), sm: 12, fluid: true },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("header", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["header"] },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["heading"], level: 2, weight: "light" },
                                "More in ",
                                post.categories[0].name)),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__recommendedPosts__["a" /* RecommendedPosts */], { posts: recommendedPosts })))),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_backpack_ui_dist_components_newsletter___default.a, { captchaSiteKey: "6LegewcUAAAAAG-5-ZTtWJ9M8cUyz7Mh0-uzNbC_" })));
    };
    return PostPreview;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));



/***/ }),

/***/ "tMiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PostHighlight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("NjDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_calloutLink__ = __webpack_require__("vMj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_calloutLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_calloutLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_categoryLabelLink__ = __webpack_require__("gOyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_categoryLabelLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_categoryLabelLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container__ = __webpack_require__("+Z/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn__ = __webpack_require__("FTur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createExcerpt__ = __webpack_require__("E8nV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getImgixUrl__ = __webpack_require__("4249");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_truncate__ = __webpack_require__("5Tmr");













var markup = function (html) { return ({ __html: html }); };
var PostHighlight = function (_a) {
    var posts = _a.posts;
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("section", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("postHighlight", __WEBPACK_IMPORTED_MODULE_3__styles_css__["postHighlightContainer"]) }, posts.map(function (post) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_container___default.a, null,
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_backpack_ui_dist_components_gridRow___default.a, null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["column1"], sm: 12, md: 6, fluid: true },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("Article-content", __WEBPACK_IMPORTED_MODULE_3__styles_css__["textContainer"]) },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_categoryLabelLink___default.a, { href: "/blog/category/lp-pathfinders" }, "Pathfinders"),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", { href: "/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") +
                                "/" + post.metadata.slug, className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["anchor"] },
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_backpack_ui_dist_components_text__["Heading"], { weight: "medium", className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["heading"] }, post.title),
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["paragraph"], dangerouslySetInnerHTML: markup(post.excerpt ?
                                    Object(__WEBPACK_IMPORTED_MODULE_12__utils_truncate__["a" /* truncate */])(post.excerpt, 25) :
                                    Object(__WEBPACK_IMPORTED_MODULE_10__utils_createExcerpt__["a" /* createExcerpt */])(post.content)) }))),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("footer", { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["footer"] },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_calloutLink___default.a, { href: "/blog/" + __WEBPACK_IMPORTED_MODULE_1_moment__(post.publicationDate).format("YYYY/MM/DD") +
                                "/" + post.metadata.slug }, "Read More"))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_gridColumn___default.a, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["column2"], sm: 12, md: 6, includeGutter: true, fluid: true },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "Article-image" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", { src: Object(__WEBPACK_IMPORTED_MODULE_11__utils_getImgixUrl__["a" /* getImgixUrl */])(post.featuredImage ?
                                post.featuredImage.url + "?auto=format&fit=crop&w=700&h=500&q=72" :
                                "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=700&h=500&q=72"), alt: "" }))))))); })));
};


/***/ }),

/***/ "xVEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reducePropsToState */
/* unused harmony export handleStateChangeOnClient */
/* unused harmony export createScripts */
/* unused harmony export Asset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect__ = __webpack_require__("vAAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_side_effect__);

var reducePropsToState = function (propsList) { return propsList
    .map(function (prop) { return prop.src; }); };
var handleStateChangeOnClient = function () { return ({}); };
var createScripts = function (state) { return state; };
var mapStateOnServer = function (state) { return createScripts(state); };
var Asset = __WEBPACK_IMPORTED_MODULE_0_react_side_effect__(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(function () { return null; });
/* harmony default export */ __webpack_exports__["a"] = (Asset);


/***/ }),

/***/ "xsyg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"listItemContainer":"styles__listItemContainer___2IXnh"};

/***/ }),

/***/ "z8Ev":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"containerWithHeading":"styles__containerWithHeading___2w8mx","button":"styles__button___1AjGF"};

/***/ }),

/***/ "zERC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("mU/R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridRow__ = __webpack_require__("t6af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridRow__);




var ArticleHeader = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_gridRow___default.a, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__("ArticleHeader", __WEBPACK_IMPORTED_MODULE_2__styles_css__["articleHeader"]) }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ArticleHeader);


/***/ })

},["GAMU"]);


// WEBPACK FOOTER //
// blog.fca6cd815d75fd1581e2.js